import React from 'react'; 
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Popover from 'react-bootstrap/lib/Popover';
import OverlayTrigger from 'react-bootstrap/lib/OverlayTrigger';
import Switch from 'react-bootstrap-switch';
import FortisButton from '../../Basic/FortisButton';
import LinkButton from '../../Basic/LinkButton';
import util from '../../../lib/util';
import { browserHistory } from 'react-router';
import * as consts from '../../../constants';

class DashboardProject extends React.Component {
  resumeClicked = () => {
    const p = this.props.project;
    const appType = p.applicationType == consts.NEW_GAS_LINE_NAME_APLLICATION_TYPE ? consts.NEW_GAS_LINE_URL : consts.SERVICE_REMOVAL_URL;
    browserHistory.push(`/${appType}?projectNo=${p.projectNo}`);
  }
  copyClicked = () => {
    const p = this.props.project;
    const appType = p.applicationType == consts.NEW_GAS_LINE_NAME_APLLICATION_TYPE ? consts.NEW_GAS_LINE_URL : consts.SERVICE_REMOVAL_URL;
    browserHistory.push(`/${appType}?projectNo=${p.projectNo}&isCopy=true`);
  }
  projectDetailsClicked = () => {
    const p = this.props.project;
    browserHistory.push(`/projectdetails?projectNo=${p.projectNo}&appType=${p.applicationType}`);
  }

  componentWillReceiveProps(p) {
    if (p.isProjectCancelled) {
      p.dispatch({ type: 'CANCELLED_PROJECT', cancelledProject: null });
      p.dispatch({ type: 'GET_PROJECT_LIST', bp: p.user && p.user.bpNumber });
    }
  }
  onCancelClick = () => {
    const p = this.props;
    const modalLookup = window.osa && window.osa.commonLookup.modal;
    const data = {
      headerText: modalLookup.cancelService.header,
      bodyText: modalLookup.cancelService.body,
      actionButtonText: "OK",
      closeButtonText: "Cancel",
      onActionClicked: () => {
        let model = {
          ProjectNo: p.project && p.project.projectNo
        };
        p.dispatch({ type: 'CANCEL_PROJECT', model: model });
      }
    };
    p.dispatch({ type: 'SHOW_MODAL', data: data });
  }

  toggleNotification = (p) => {
   if(p.isAllEmail) {
   const modalLookup = window.osa && window.osa.commonLookup.modal; 
    const data = {
      headerText:  modalLookup.turnoffNotification.header,
      bodyText:  modalLookup.turnoffNotification.body,
      actionButtonText: "OK",
      closeButtonText: "Cancel",
      onActionClicked: () => {
        this.props.switchProject(p);
      }
    };
    this.props.dispatch({ type: 'SHOW_MODAL', data: data });
   }
   else {
      this.props.switchProject(p);
   }
  }

  render() {
    const p = this.props.project;
    const st = window.osa && window.osa.lookup && window.osa.lookup.status;
    const stype = window.osa && window.osa.lookup && window.osa.lookup.serviceType;
    return (
      <div className="row" style={{ borderBottom: "1px solid #dddddd", paddingTop: "5px" }}>
        <div className="col-md-6">
          <div>
            <div className="row">
              <div className="col-md-12">
                <i className="fa fa-chevron-circle-right" style={{ color: "#f4ae11" }}>
                  <a onClick={this.projectDetailsClicked}> {this.props.address} <br /> Project number #{p.projectNo} </a>
                </i>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                Status: {st && st[p.status].title}&nbsp;
                <OverlayTrigger trigger={['hover', 'focus']} placement="right" overlay={(<Popover id={`tt-${p.projectNo}`}>{st && st[p.status].tip}</Popover>)}>
                  <i className="fa fa-info-circle info-icon" />
                </OverlayTrigger>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">Service product: {stype && stype[p.applicationType]} </div>
            </div>
            <div className="row">
              <div className="col-md-12">Created date: {util.toFullDateString(util.dateFromString(p.createdDate))}  </div>
            </div>
            <div className="row">
              <div className="col-md-12">Scheduled date: {util.toFullDateString(util.dateFromString(p.scheduleStartDate))} - {util.toFullDateString(util.dateFromString(p.scheduleEndDate))} </div>
            </div>
          </div>
        </div>
        <div className="col-md-4">
          {(p && p.status === 'In Progress') && p.isWeb ?
            <div>
              <div style={{ marginLeft: "10px" }}><FortisButton text="Resume request" onClick={this.resumeClicked} /></div>
              <div className="db-link">
                <LinkButton text="Cancel new service request" onClick={this.onCancelClick} />
              </div>
            </div>
            : null
          }
          {p.isWeb ?
            <div className="db-link">
              <LinkButton text="Create similar service request" onClick={this.copyClicked} />
            </div>
            : null
          }
        </div>
        <div className="col-md-2" style={{ padding: "0px" }}>
          {p.status === 'Submitted' && p.isWeb ?
            <div className="form-group" style={{ marginBottom: "0px", marginLeft: "0px", padding: "0px" }}>
              <b>Email notifications</b>
              <div className="checkbox" style={{ padding: "0px" }}>
                <Switch bsSize="mini" value={p.isAllEmail} onChange={() => this.toggleNotification(p)} />
              </div>
            </div>
            : null
          }
        </div>
      </div>
    );
  }
}

DashboardProject.propTypes = {
  isProjectCancelled: PropTypes.bool,
  user: PropTypes.object
};

const mapStateToProps = (state) => {
  return {
    isProjectCancelled: state.gas.cancelledProject && state.gas.cancelledProject.isSuccess,
    user: state.gas.user
  };
};
export default connect(mapStateToProps)(DashboardProject);


